import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import Sidebar from "@/pages/home/components/Sidebar";
import HotPlots from "@/pages/home/components/HotPlots";
import SpecialShowcase from "@/pages/home/components/SpecialShowcase";
import SiteIntro from "@/pages/home/components/SiteIntro";
import SectionHeading from "@/components/feature/SectionHeading";
import WorkCard from "@/components/feature/WorkCard";
import { allWorks, getFeatured, sortWorks } from "@/utils/catalog";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title: "妻子的朋友 - 热门影视剧剧情介绍与观影推荐",
    description:
      "妻子的朋友网站提供丰富的影视剧剧情介绍、角色分析及推荐内容，涵盖各类影视作品，让您轻松了解热门影视信息。",
    keywords: "妻子的朋友,影视剧情,影视推荐,电视剧介绍,电影解析,影视作品,剧情解读,影视资讯",
  });

  const featured = getFeatured();
  const latest = sortWorks(allWorks, "updated").slice(0, 6);
  const hotPlots = [...allWorks].sort((a, b) => b.popularity - a.popularity).slice(0, 4);

  return (
    <div className="w-full">
      <HeroCarousel items={featured} />

      <div className="mx-auto w-full max-w-[1360px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="快速导航"
          title="按分类浏览"
          description="电影、电视剧、网络剧三大分类，快速进入你感兴趣的内容板块。"
        />
        <CategoryEntries />
      </div>

      <div className="mx-auto w-full max-w-[1360px] px-4 pb-10 md:px-6 md:pb-14">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[250px_1fr] lg:gap-8">
          <div className="order-2 lg:order-1">
            <Sidebar />
          </div>

          <div className="order-1 flex flex-col gap-10 lg:order-2">
            <section>
              <SectionHeading
                eyebrow="最新上线"
                title="最新更新影视"
                description="按更新时间排列，第一时间掌握刚上线或刚完结的作品。"
                moreTo="/category/movie"
                moreLabel="更多作品"
              />
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
                {latest.map((w, i) => (
                  <WorkCard key={w.id} work={w} index={i} />
                ))}
              </div>
            </section>

            <section>
              <SectionHeading
                eyebrow="热门剧情"
                title="热门剧情推荐"
                description="精选高热度影视剧的剧情摘要与看点，帮你快速判断是否值得一看。"
                moreTo="/search"
                moreLabel="搜索更多"
              />
              <HotPlots items={hotPlots} />
            </section>
          </div>
        </div>
      </div>

      <section className="border-y border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-[1360px] px-4 py-10 md:px-6 md:py-14">
          <SectionHeading
            eyebrow="专题合集"
            title="影视专题精选"
            description="我们按主题策划了多个片单，从悬疑刑侦到治愈生活，帮你成体系地发现好作品。"
            moreTo="/special"
          />
          <SpecialShowcase />
        </div>
      </section>

      <div className="mx-auto w-full max-w-[1360px] px-4 py-10 md:px-6 md:py-14">
        <SiteIntro />
      </div>
    </div>
  );
}